import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import queryString from 'query-string';
import LocalizedStrings from 'react-localization';
import InsuranceTitle from '../components/InsuranceTitle';
import InsuranceParams from '../components/InsuranceParams';
import MakeBanner from '../components/banners/MakeBanner';
import InsuranceFeatures from '../components/InsuranceFeatures';
import InsuranceItemContainer from '../containers/InsuranceItemContainer';
import CompareBannerContainer from '../containers/CompareBannerContainer';
import {MorePossibilitiesModule} from 'polisua-react-modules/index.esm';

function KascoItem(props) {
  useEffect(() => {
    props.addToDataLayer();
    window.scrollTo(0, 0);
  }, []);

  const handleRedirect = (e) => {
    e.preventDefault();
    const idx = props.location.search.indexOf('&id');
    const url = props.location.search.slice(0, idx);
    props.history.push({
      pathname: props.locale === 'ua' ? '/uk/kasko/list' : '/kasko/list',
      search: url,
    });
  };

  const values = queryString.parse(props.location.search);

  const item = JSON.parse(localStorage.getItem('offers')).offers.find((el) => el.insuranceCompanyCode === values.id);

  const strings = new LocalizedStrings({
    ru: {
      back: 'вернуться назад',
    },
    ua: {
      back: 'Повернутися назад',
    },
  });

  strings.setLanguage(props.locale);

  return (
    <div>
      <InsuranceTitle locale={props.locale} />
      <InsuranceParams locale={props.locale} />
      <section id="kasco_offer" className="container kasco_offer-inside">
        <a onClick={handleRedirect} href="#/" className="btn-back"><svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L1 9" stroke="#374656" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>{strings.back}</a>
        <div className="row">
          <div className="left-block">
            <InsuranceItemContainer locale={props.locale} item={item} />
            <CompareBannerContainer locale={props.locale} />
          </div>
          <div className="right-block">
            <a href={props.locale === "ua" ? "https://polis.ua/uk/osago" : "https://polis.ua/osago"}><MakeBanner locale={props.locale} /></a>
            {/*<VideoBanner locale={props.locale} />*/}
          </div>
        </div>
      </section>
      <section id="polis-about">
        <div className="container">
          <InsuranceFeatures locale={props.locale} />
          {/*<InsurancePayItems locale={props.locale} />*/}
          <MorePossibilitiesModule lang={props.locale === 'ua' ? 'uk' : 'ru'} />
        </div>
      </section>
    </div>
  );
}

export default withRouter(KascoItem);
